var React = require('react');

function F3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"F3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"56.14 21.27 56.1 0.48 8.28 0.76 21.12 21.81 56.14 21.27","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("polygon",{"points":"7.36 0 5.45 20.7 4.64 29.5 2.73 50.2 0 79.69 22.98 81.82 24.89 61.11 25.7 52.32 51.58 54.71 53.49 34.01 27.61 31.62 28.68 20.05 7.36 0","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

F3.defaultProps = {"viewBox":"0 0 56.14 81.82"};

module.exports = F3;

F3.default = F3;
